import { call, put, takeEvery } from 'redux-saga/effects';
import { AddNewDealerRequestEvent, NewDealerActionKeys } from '..';
import { IEntityWithMessages } from '../../../services/HttpService';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { processMessages, showFailedRequestDialog } from '../../sagaUtils';
import { newDealerActionCreators } from '../newDealerActionCreators';
import * as api from '../newDealerApi';
import { INewDealerRequestEvent } from '../newDealerInterfaces';

function* addNewDealerRequestEvent(action: AddNewDealerRequestEvent) {
  yield put(newDealerActionCreators.toggleEventSave(action.payload));
  const response: IApiExecuteRespone<IEntityWithMessages<INewDealerRequestEvent>> = yield call(
    api.addNewDealerRequestEvent,
    action.payload
  );

  if (!response.requestFailed && response.value) {
    yield processMessages(response.value);

    if (response.value.value) {
      yield put(newDealerActionCreators.setEvent(response.value.value));
    }
  } else {
    yield showFailedRequestDialog(response);
  }

  yield put(newDealerActionCreators.toggleEventSave(action.payload));
}

export function* watchAddNewDealerRequestEvent() {
  yield takeEvery(NewDealerActionKeys.ADD_NEW_DEALER_REQUEST_EVENT, addNewDealerRequestEvent);
}
